// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'C:/Users/15103/Desktop/project/newmachine-admmin2/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import BarChartOutlined from 'C:/Users/15103/Desktop/project/newmachine-admmin2/node_modules/@ant-design/icons/es/icons/BarChartOutlined';
import CrownOutlined from 'C:/Users/15103/Desktop/project/newmachine-admmin2/node_modules/@ant-design/icons/es/icons/CrownOutlined';
export default { SmileOutlined, BarChartOutlined, CrownOutlined };
